// extracted by mini-css-extract-plugin
export default {"SimpleDropdown_container":"styles_SimpleDropdown_container__ptwZx","SimpleDropdown_options":"styles_SimpleDropdown_options__LKjoe","popperContainer":"styles_popperContainer__+GwjZ"};